import { Authorization } from '@ananasbear/auth'
import { auth } from '@/configs/endpoints'

const options = {
	tokenKey: 'Bearer',
	tokenKeyResponse: 'access',
	urls: auth
}

const authorization = new Authorization(options)

export default authorization